import { createContext, useContext, useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import type { BotStatus } from '../domain/types';

// Fuente ÚNICA de verdad de "cliente conectado" (doc 12 · 0.3.0 p6).
// Antes, cabecera y dashboard calculaban Date.now() cada uno en su render con un
// corte duro a 90 s y sin reloj: podían quedar a lados opuestos del corte y
// contradecirse. Ahora: un solo cálculo (en AppShell), con tick de 1 s para que
// el corte se cruce en un render y con histéresis para no parpadear en el límite.
const CONNECT_MS = 90_000; // reporte más reciente que esto → conectado
const DISCONNECT_MS = 120_000; // histéresis: estando conectado, solo cae pasado esto

export function useClientConnectedValue(status: BotStatus | undefined | null): boolean {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const prev = useRef(false);
  const at = status?.lastReportAt ? Date.parse(status.lastReportAt) : NaN;
  const age = Number.isFinite(at) ? now - at : Infinity;
  const connected = prev.current ? age < DISCONNECT_MS : age < CONNECT_MS;
  prev.current = connected;
  return connected;
}

const ClientConnectionContext = createContext(false);

export function ClientConnectionProvider({ connected, children }: { connected: boolean; children: ReactNode }) {
  return <ClientConnectionContext.Provider value={connected}>{children}</ClientConnectionContext.Provider>;
}

export function useClientConnected(): boolean {
  return useContext(ClientConnectionContext);
}
